/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UtenteListItemDto } from '../../models/utente-list-item-dto';

export interface ApiAuthUtenteUnioneListGet$Params {
    /**
     * Id dell'unione per cui caricare gli utenti
     */
    unioneId?: number;
}

export function apiAuthUtenteUnioneListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiAuthUtenteUnioneListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<UtenteListItemDto>>> {
    const rb = new RequestBuilder(rootUrl, apiAuthUtenteUnioneListGet.PATH, 'get');
    if (params) {
        rb.query('unioneId', params.unioneId, {});
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<UtenteListItemDto>>;
        }),
    );
}

apiAuthUtenteUnioneListGet.PATH = '/api/auth/utente-unione-list';
